import Utils from "./utils";
import { ApiControllerSettings } from "@infoland/iprova-api";
import storeHelper from "./store/store-helper";
export default class {
    public static get iProvaUrl(): string {
        // ensure the url does not have trailing '/'
        return (window as any).iProvaUrl;
    }

    /** Sets the iprova url */
    public static set iProvaUrl(iprovaUrl: string) {
        // ensure the url does not have trailing '/'
        (window as any).iProvaUrl = iprovaUrl.replace(/\/$/, "");
    }

    /** Gets the url to the iProva API root */
    public static get iProvaApiUrl(): string {
        return this.iProvaUrl + "/api";
    }
    public static GetAuthenticatedUrl(url: string): string {
        let seperator = url.indexOf("?") == -1 ? "?" : "&";
        return `${url}${seperator}${ApiControllerSettings.xsrfHeaderName}=${encodeURIComponent(
            Utils.getCookie(ApiControllerSettings.xsrfCookieName)
        )}`;
    }
}
